import PasspotizationIcon from './component'

export default PasspotizationIcon